import { Theme } from '@mui/material/styles';
import { CSSObject } from 'tss-react';

export const getBaseStyles = (theme: Theme): Record<string, CSSObject> => ({
  modal: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 0,
    paddingTop: '100px',
    pointerEvents: 'none',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
      padding: `${theme.spacing(2)} ${theme.spacing(2)}`,
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    borderRadius: 10,
    minWidth: 360,
    maxWidth: 460,
    outline: 'none',
    pointerEvents: 'auto',
    backgroundColor: '#ffffff',
    border: '1px solid rgba(0,0,0,0.06)',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1), 0 1px 4px rgba(0,0,0,0.05)',
    position: 'relative' as const,
    overflow: 'hidden' as const,
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      width: '100%',
      maxWidth: '100%',
      borderRadius: 8,
      padding: theme.spacing(1.5, 2),
    },
  },
  iconPill: {
    width: 38,
    height: 38,
    minWidth: 38,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  icon: {
    fontSize: 22,
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25),
    flex: 1,
    minWidth: 0,
  },
  label: {
    fontSize: '0.9rem',
    fontWeight: 700,
    color: '#111827',
    letterSpacing: '0.2px',
    lineHeight: 1.2,
  },
  message: {
    fontSize: '0.85rem',
    fontWeight: 400,
    color: '#6b7280',
    lineHeight: 1.5,
  },
  closeBtn: {
    color: '#9ca3af',
    padding: theme.spacing(0.5),
    flexShrink: 0,
    borderRadius: '6px',
    '&:hover': {
      background: 'rgba(0,0,0,0.04)',
      color: '#6b7280',
    },
  },
  accentBar: {
    position: 'absolute' as const,
    left: 0,
    top: 0,
    bottom: 0,
    width: '5px',
  },
});
